import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DomEventsUtilsService {
  clickedTarget: Subject<EventTarget> = new Subject<EventTarget>();
}
